module.exports = __webpack_public_path__ + "assets/icon-message-gray.9718c406.svg";